export default "__VITE_ASSET__CEADUbeI__"